import { message } from "antd";
import i18next from "i18next";
import { extend } from "umi-request";
import { getToken } from "./security";

// const codeMessage = {
//   200: "Le serveur a renvoyé avec succès les données demandées.",
//   201: "Les données nouvelles ou modifiées sont réussies.",
//   202: "Une requête est entrée dans la file d'attente d'arrière-plan (tâche asynchrone).",
//   204: "Les données ont été supprimées avec succès.",
//   400: "La requête a été effectuée avec une erreur et le serveur n'a effectué aucune opération de données nouvelle ou modifiée.",
//   401: "L'utilisateur n'a pas d'autorisation (le jeton, le nom d'utilisateur, le mot de passe est incorrect).",
//   403: "L'utilisateur est autorisé, mais l'accès est interdit.",
//   404: "La demande est faite pour un enregistrement qui n'existe pas et le serveur ne fonctionne pas.",
//   406: "Le format de la demande n'est pas disponible.",
//   410: "La ressource demandée est définitivement supprimée et ne sera pas récupérée.",
//   422: "Une erreur de validation s'est produite lors de la création d'un objet.",
//   500: "Une erreur s'est produite sur le serveur. Veuillez vérifier le serveur.",
//   502: "Erreur de passerelle",
//   503: "Le service n'est pas disponible et le serveur est temporairement surchargé ou maintenu.",
//   504: "La passerelle a expiré.",
// };

const errorHandler = (error) => {
  const { response, data } = error;

  if (response && response.status) {
    const { status } = response;

    switch (status) {
      case 401:
        window.location.replace(`/`);
        break;
      // case 500:
      //   toast.error("Une erreur s'est produite sur le serveur.");
      //   window.location.replace(`${process.env.REACT_APP_BASE_API}home`);
      //   break;
      // case 403:
      //   router.push(`${_ENTRY_PATH}Exception/403`);
      //   location.reload();
      //   break;
      // case 404:
      //   router.push(`${_ENTRY_PATH}Exception/404`);
      //   break;
      default:
        console.log("request error");
    }

    switch (data.error) {
      case "jwt expired":
        message.error(i18next.t("server.session.expired"));
        window.location.replace(`/`);
        break;
      case "jwt malformed":
        message.error(i18next.t("server.session.expired"));
        window.location.replace(`/`);
        break;

      default:
        console.log("request error");
    }
    return response;
  }
  throw error;
};

const defaultOptions = {
  mode: "cors",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  credentials: "same-origin",
};

const request = extend({
  useCache: false,
  timeout: 30000,
  ...defaultOptions,
  errorHandler,
  getResponse: true,
});

request.interceptors.request.use(
  (url, options) => {
    const { headers } = options;
    const token = getToken("access_token");
    if (token) {
      return {
        url,
        options: {
          ...options,
          headers: {
            ...headers,
            Authorization: getToken("access_token"),
          },
        },
      };
    }
    return {
      url,
      options,
    };
  },
  { global: false }
);
export default request;
